import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Baseline } from './global/Baseline';
import { PineconeTheme } from './PineconeTheme';
import { ConstellationThemeProvider } from '../../components/shared/ConstellationThemeProvider';

export const PineconeThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider theme={PineconeTheme}>
      <ConstellationThemeProvider>
        <Baseline />
        {children}
      </ConstellationThemeProvider>
    </ThemeProvider>
  );
};
